import "./Physicians.module.css";
import ClinicHeader from "@/reusable_sections/Header";
import TheFutureOfHairHealth from "./sections/TheFutureOfHairHealth";
import TheScienceOfAlluvi from "./sections/TheScienceOfAlluvi";
import StartYourTransformation from "./sections/StartYourTransformation";
import PatientResources from "@/reusable_sections/Footer";
export default function PhysiciansPage() {
  return <div>
      <ClinicHeader />
      <TheFutureOfHairHealth />
      <TheScienceOfAlluvi />
      <StartYourTransformation />
      <PatientResources />
    </div>;
}